import axios from "axios";

export const API_URL = process.env.NEXT_PUBLIC_API_URI;
export const API_KEY = process.env.NEXT_PUBLIC_API_KEY;

const axiosInstance = axios.create({
  baseURL: API_URL + "/api/v1",
  withCredentials: true,
  timeout: 300000, // 5 minutes
  headers: {
    Accept: "application/json",
    "x-api-key": API_KEY,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

export const postData = (domain: string, data: any) => {
  return axiosInstance.post(`/${domain}`, data, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const postDataImg = (domain: string, data: any) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item: any) => {
        formData.append(key, item);
      });
    } else {
      formData.append(key, data[key]);
    }
  });

  return axiosInstance.post(`/${domain}`, formData, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const getData = (domain: string, data: any = {}) => {
  return axiosInstance.get(`/${domain}`, {
    params: data,
  });
};

export const deleteData = (domain: string) => {
  return axiosInstance.delete(`/${domain}`, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const updateData = (domain: string, data: any) => {
  return axiosInstance.put(`/${domain}`, data, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const updateDataImg = (domain: string, data: any) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item: any) => {
        formData.append(key, item);
      });
    } else {
      formData.append(key, data[key]);
    }
  });

  return axiosInstance.put(`/${domain}`, formData, {
    headers: {
      Accept: "application/json",
    },
  });
};
